import { Component, OnInit } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-helpbutton-new-department-dashboard',
  templateUrl: './helpbutton-new-department-dashboard.component.html',
  styleUrls: ['./helpbutton-new-department-dashboard.component.scss']
})
export class HelpbuttonNewDepartmentDashboardComponent implements OnInit {

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-columns', 'helpbutton-page.new department', '/helpbutton/departments', [new BRoute('helpbutton-page.helpbutton', '/helpbutton'), new BRoute('helpbutton-page.departments', '/helpbutton/departments'), new BRoute('helpbutton-page.new department')]));
  }
}
